import { ClaimGroupMessages } from "src/languages/interfaces";

enum EClaimGroupModule {
  CONCRETE_BATCHING_PLANT = "concreteBatchingPlant",
  GRAVEL = "gravel",
  CHARACTERISTIC = "characteristic",
  CLASSIFICATION = "classification",
  SUPPLY = "supply",
  SUPPLIER = "supplier",
  CONCRETE_BATCHING_PLANT_GROUP = "concreteBatchingPlantGroup",
  PRODUCT_GROUP = "productGroup",
  CONCRETE_RECIPE = "concreteRecipe",
  CONCRETE_BATCHING_PLANT_REGIONAL = "concreteBatchingPlantRegional",
  SLUMP = "slump",
  MEASURE_UNIT_TYPE = "measureUnitType",
  TECHNICAL_DATA_SUPPLY = "technicalDataSupply",
  COST_SUPPLY = "costSupply",
  ABRAMS_CURVE = "abramsCurve",
  CONCRETE_RECIPE_FAMILY = "concreteRecipeFamily",
  COPY_IN_BATCH = "copyInBatch",
  CHANGE_IN_BATCH = "changeInBatch",
  USER_RIGHTS_CONTROL = "userRightsControl",
  EXTERNAL_ID = "externalId",
  CSV_IMPORT = "csvImport",
  CONCRETE_MIX_DESIGN_SHEET = "concreteMixDesignSheet",
  CONCRETE_MIX_DESIGN_SHEET_PARAMETERS = "concreteMixDesignSheetParameters",
  AGGREGATE_TEST = "aggregateTest",
  AGGREGATE_TEST_REPORT = "aggregateTestReport",
  SIEVE = "sieve",
  RESPONSIBLE_ENGINEER = "responsibleEngineer",
  LABORATORY = "laboratory",
  LABORATORY_TECHNICIAN = "laboratoryTechnician",
  STANDARD = "standard",
  INTEGRATIONS = "integrations",
  VEHICLES = "vehicles",
  EMPLOYEES = "employees",
  REPORTS = "reports",
  GENERAL_PARAMETERS = "generalParameters",
  EXPEDITION = "expedition",
  AGGREGATE_MOISTURE = "aggregateMoisture",
  LOAD_TICKETS = "loadTickets",
  DELIVERIES_TICKETS = "deliveriesTickets",
  LOAD_REUSE = "loadReuse",
  INVOICES = "invoices",
  WEIGHING_LINK = "weighingLink",
  INVENTORY = "inventory",
  INVENTORY_CLOSURE = "inventoryClosure",
  DAILY_CLOSING = "dailyClosing",
  INVOICE_STUB = "invoiceStub",
  APPROVAL_OF_ADDITIONAL_FEES = "approvalOfAdditionalFees",
  SCHEDULINGS = "schedulings",
  DELIVERY = "delivery",
  RESERVATION = "reservation",
  CONCRETE_BATCHING_PLANTS_DISPATCH = "concreteBatchingPlantsDispatch",
  CONCRETE_BATCHING_PLANT_GENERAL_PARAMETERS = "concreteBatchingPlantGeneralParameters",
  CONCRETE_BATCHING_PLANT_OPENING_HOURS_PARAMETERS = "concreteBatchingPlantOpeningHoursParameters",
  CONCRETE_BATCHING_PLANT_AVERAGE_DURATION_PARAMETERS = "concreteBatchingPlantAverageDurationParameters",
  CONCRETE_BATCHING_PLANT_MOLDING_PARAMETERS = "concreteBatchingPlantMoldingParameters",
  CONCRETE_BATCHING_PLANT_DAILY_CLOSING_PARAMETERS = "concreteBatchingPlantDailyClosingParameters",
  CONCRETE_BATCHING_PLANT_TAX_DOCUMENT_PARAMETERS = "concreteBatchingPlantTaxDocumentParameters",
  LOADING_POINTS = "loadingPoints",
  LOADING_POINT_LOCATIONS = "loadingPointLocations",
  DELIVERY_ROUTES = "deliveryRoutes",
  PUMPING_TYPES = "pumpingTypes",
  PIECES_TO_BE_CONCRETED = "piecesToBeConcreted",
  DEFAULT_DURATIONS_BY_PUMPING_TYPE = "defaultDurationsByPumpingType",
  HOLIDAYS = "holidays",
  REASONS = "reasons",
  CONCRETE_BATCHING_PLANT_GROUP_DISPATCH = "concreteBatchingPlantGroupDispatch",
  CONCRETE_BATCHING_PLANT_REGIONAL_DISPATCH = "concreteBatchingPlantRegionalDispatch",
  TAX_CONFIGURATION_CONCRETE_RECIPE = "taxConfigurationConcreteRecipe",
  USERS = "users",
  GROUPS = "groups",
  ALERTS = "alerts",
  CONCRETE_DISCARD_DESTINATION = "concreteDiscardDestination",
  LOAD_TICKET_BLOCK_REASON = "loadTicketBlockReason",
  PUMPING_BLOCK_REASON = "pumpingBlockReason",
  DAILY_PRODUCTION_CLOSING_INCONSISTENCIES = "dailyProductionClosingInconsistencies",
  TIME_RECORDS = "timeRecords",
  TIME_CLOCK_CONFIGURATIONS = "timeClockConfigurations",
  BATCHPORTAL_MAINTENANCE_VIEW = "batchMaintenanceView",
  BATCHPORTAL_MAINTENANCE_EDIT = "batchMaintenanceEdit",
  BATCHPORTAL_MAINTENANCE_EXECUTE = "batchMaintenanceExecute",
  BATCHPORTAL_AUTOMATION_VIEW = "batchAutomationView",
  BATCHPORTAL_AUTOMATION_EXECUTE = "batchAutomationExecute",
  BATCHPORTAL_AUTOMATION_ADMIN = "batchAutomationAdmin",
  BATCHPORTAL_AUTOMATION_SUPER_ADMIN = "batchAutomationSuperAdmin",
  PERFORMANCE = "performance",
  LABORATORY_MODULE = "laboratoryModule",
  SPECIMEN_COLLECTION = "specimenCollection",
  SPECIMEN_RUPTURE = "specimenRupture",
  DELIVERY_TICKET_SPECIMENS = "deliveryTicketSpecimens",
  COLLECTION_SCHEDULE = "collectionSchedule",
  RUPTURE_SCHEDULE = "ruptureSchedule",
  ISSUE_CERTIFICATE = "issueCertificate",
  ISSUED_CERTIFICATES = "issuedCertificates",
  PRESSES = "presses",
  CERTIFICATE_PARAMETERS = "certificateParameters",
  LABORATORY_STATISTICS = "laboratoryStatistics",
  LOW_STRENGTH_APPROVAL = "lowStrengthApproval"
}

const claimGroupObject = {
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT]: {
    id: "1",
    title: ClaimGroupMessages.concreteBatchingPlant
  },
  [EClaimGroupModule.GRAVEL]: {
    id: "2",
    title: ClaimGroupMessages.gravel
  },
  [EClaimGroupModule.CHARACTERISTIC]: {
    id: "3",
    title: ClaimGroupMessages.characteristic
  },
  [EClaimGroupModule.CLASSIFICATION]: {
    id: "4",
    title: ClaimGroupMessages.classification
  },
  [EClaimGroupModule.SUPPLIER]: {
    id: "5",
    title: ClaimGroupMessages.supplier
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_GROUP]: {
    id: "6",
    title: ClaimGroupMessages.concreteBatchingPlantGroup
  },
  [EClaimGroupModule.PRODUCT_GROUP]: {
    id: "7",
    title: ClaimGroupMessages.productGroup
  },
  [EClaimGroupModule.CONCRETE_RECIPE]: {
    id: "8",
    title: ClaimGroupMessages.concreteRecipe
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_REGIONAL]: {
    id: "9",
    title: ClaimGroupMessages.concreteBatchingPlantRegional
  },
  [EClaimGroupModule.SLUMP]: {
    id: "10",
    title: ClaimGroupMessages.slump
  },
  [EClaimGroupModule.MEASURE_UNIT_TYPE]: {
    id: "11",
    title: ClaimGroupMessages.measureUnitType
  },
  [EClaimGroupModule.TECHNICAL_DATA_SUPPLY]: {
    id: "12",
    title: ClaimGroupMessages.technicalDataSupply
  },
  [EClaimGroupModule.COST_SUPPLY]: {
    id: "13",
    title: ClaimGroupMessages.costSupply
  },
  [EClaimGroupModule.ABRAMS_CURVE]: {
    id: "14",
    title: ClaimGroupMessages.abramsCurve
  },
  [EClaimGroupModule.CONCRETE_RECIPE_FAMILY]: {
    id: "15",
    title: ClaimGroupMessages.concreteRecipeFamily
  },
  [EClaimGroupModule.COPY_IN_BATCH]: {
    id: "16",
    title: ClaimGroupMessages.copyInBatch
  },
  [EClaimGroupModule.CHANGE_IN_BATCH]: {
    id: "17",
    title: ClaimGroupMessages.changeInBatch
  },
  [EClaimGroupModule.USER_RIGHTS_CONTROL]: {
    id: "18",
    title: ClaimGroupMessages.userRightsControl
  },
  [EClaimGroupModule.EXTERNAL_ID]: {
    id: "19",
    title: ClaimGroupMessages.externalId
  },
  [EClaimGroupModule.CSV_IMPORT]: {
    id: "20",
    title: ClaimGroupMessages.csvImport
  },
  [EClaimGroupModule.SUPPLY]: {
    id: "21",
    title: ClaimGroupMessages.supply
  },
  [EClaimGroupModule.CONCRETE_MIX_DESIGN_SHEET]: {
    id: "22",
    title: ClaimGroupMessages.concreteMixDesignSheet
  },
  [EClaimGroupModule.CONCRETE_MIX_DESIGN_SHEET_PARAMETERS]: {
    id: "23",
    title: ClaimGroupMessages.concreteMixDesignSheetParameters
  },
  [EClaimGroupModule.AGGREGATE_TEST]: {
    id: "24",
    title: ClaimGroupMessages.aggregateTest
  },
  [EClaimGroupModule.AGGREGATE_TEST_REPORT]: {
    id: "25",
    title: ClaimGroupMessages.aggregateTestReport
  },
  [EClaimGroupModule.SIEVE]: {
    id: "26",
    title: ClaimGroupMessages.sieve
  },
  [EClaimGroupModule.RESPONSIBLE_ENGINEER]: {
    id: "27",
    title: ClaimGroupMessages.responsibleEngineer
  },
  [EClaimGroupModule.LABORATORY]: {
    id: "28",
    title: ClaimGroupMessages.laboratory
  },
  [EClaimGroupModule.LABORATORY_TECHNICIAN]: {
    id: "29",
    title: ClaimGroupMessages.laboratoryTechnician
  },
  [EClaimGroupModule.STANDARD]: {
    id: "30",
    title: ClaimGroupMessages.standard
  },
  [EClaimGroupModule.INTEGRATIONS]: {
    id: "32",
    title: ClaimGroupMessages.integrations
  },
  [EClaimGroupModule.VEHICLES]: {
    id: "33",
    title: ClaimGroupMessages.vehicles
  },
  [EClaimGroupModule.EMPLOYEES]: {
    id: "34",
    title: ClaimGroupMessages.employees
  },
  [EClaimGroupModule.REPORTS]: {
    id: "35",
    title: ClaimGroupMessages.reports
  },
  [EClaimGroupModule.GENERAL_PARAMETERS]: {
    id: "36",
    title: ClaimGroupMessages.generalParameters
  },
  [EClaimGroupModule.EXPEDITION]: {
    id: "37",
    title: ClaimGroupMessages.expedition
  },
  [EClaimGroupModule.AGGREGATE_MOISTURE]: {
    id: "38",
    title: ClaimGroupMessages.aggregateMoisture
  },
  [EClaimGroupModule.LOAD_TICKETS]: {
    id: "39",
    title: ClaimGroupMessages.loadTickets
  },
  [EClaimGroupModule.DELIVERIES_TICKETS]: {
    id: "40",
    title: ClaimGroupMessages.deliveriesTickets
  },
  [EClaimGroupModule.LOAD_REUSE]: {
    id: "41",
    title: ClaimGroupMessages.loadReuse
  },
  [EClaimGroupModule.INVOICES]: {
    id: "42",
    title: ClaimGroupMessages.invoices
  },
  [EClaimGroupModule.WEIGHING_LINK]: {
    id: "43",
    title: ClaimGroupMessages.weighingLink
  },
  [EClaimGroupModule.INVENTORY]: {
    id: "44",
    title: ClaimGroupMessages.inventory
  },
  [EClaimGroupModule.INVENTORY_CLOSURE]: {
    id: "45",
    title: ClaimGroupMessages.inventoryClosure
  },
  [EClaimGroupModule.DAILY_CLOSING]: {
    id: "46",
    title: ClaimGroupMessages.dailyClosing
  },
  [EClaimGroupModule.INVOICE_STUB]: {
    id: "47",
    title: ClaimGroupMessages.invoiceStub
  },
  [EClaimGroupModule.APPROVAL_OF_ADDITIONAL_FEES]: {
    id: "48",
    title: ClaimGroupMessages.approvalOfAdditionalFees
  },
  [EClaimGroupModule.SCHEDULINGS]: {
    id: "49",
    title: ClaimGroupMessages.schedulings
  },
  [EClaimGroupModule.DELIVERY]: {
    id: "52",
    title: ClaimGroupMessages.delivery
  },
  [EClaimGroupModule.RESERVATION]: {
    id: "53",
    title: ClaimGroupMessages.reservation
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANTS_DISPATCH]: {
    id: "54",
    title: ClaimGroupMessages.concreteBatchingPlantsDispatch
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_GENERAL_PARAMETERS]: {
    id: "55",
    title: ClaimGroupMessages.concreteBatchingPlantGeneralParameters
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_OPENING_HOURS_PARAMETERS]: {
    id: "56",
    title: ClaimGroupMessages.concreteBatchingPlantOpeningHoursParameters
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_AVERAGE_DURATION_PARAMETERS]: {
    id: "57",
    title: ClaimGroupMessages.concreteBatchingPlantAverageDurationParameters
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_MOLDING_PARAMETERS]: {
    id: "58",
    title: ClaimGroupMessages.concreteBatchingPlantMoldingParameters
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_DAILY_CLOSING_PARAMETERS]: {
    id: "59",
    title: ClaimGroupMessages.concreteBatchingPlantDailyClosingParameters
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_TAX_DOCUMENT_PARAMETERS]: {
    id: "60",
    title: ClaimGroupMessages.concreteBatchingPlantTaxDocumentParameters
  },
  [EClaimGroupModule.LOADING_POINTS]: {
    id: "61",
    title: ClaimGroupMessages.loadingPoints
  },
  [EClaimGroupModule.LOADING_POINT_LOCATIONS]: {
    id: "62",
    title: ClaimGroupMessages.loadingPointLocations
  },
  [EClaimGroupModule.DELIVERY_ROUTES]: {
    id: "63",
    title: ClaimGroupMessages.deliveryRoutes
  },
  [EClaimGroupModule.PUMPING_TYPES]: {
    id: "64",
    title: ClaimGroupMessages.pumpingTypes
  },
  [EClaimGroupModule.PIECES_TO_BE_CONCRETED]: {
    id: "65",
    title: ClaimGroupMessages.piecesToBeConcreted
  },
  [EClaimGroupModule.DEFAULT_DURATIONS_BY_PUMPING_TYPE]: {
    id: "66",
    title: ClaimGroupMessages.defaultDurationsByPumpingType
  },
  [EClaimGroupModule.HOLIDAYS]: {
    id: "67",
    title: ClaimGroupMessages.holidays
  },
  [EClaimGroupModule.REASONS]: {
    id: "68",
    title: ClaimGroupMessages.reasons
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_GROUP_DISPATCH]: {
    id: "50",
    title: ClaimGroupMessages.concreteBatchingPlantGroupDispatch
  },
  [EClaimGroupModule.CONCRETE_BATCHING_PLANT_REGIONAL_DISPATCH]: {
    id: "51",
    title: ClaimGroupMessages.concreteBatchingPlantRegionalDispatch
  },
  [EClaimGroupModule.TAX_CONFIGURATION_CONCRETE_RECIPE]: {
    id: "69",
    title: ClaimGroupMessages.taxConfigurationConcreteRecipe
  },
  [EClaimGroupModule.USERS]: {
    id: "70",
    title: ClaimGroupMessages.users
  },
  [EClaimGroupModule.GROUPS]: {
    id: "71",
    title: ClaimGroupMessages.groups
  },
  [EClaimGroupModule.ALERTS]: {
    id: "72",
    title: ClaimGroupMessages.alerts
  },
  [EClaimGroupModule.CONCRETE_DISCARD_DESTINATION]: {
    id: "73",
    title: ClaimGroupMessages.concreteDiscardDestination
  },
  [EClaimGroupModule.LOAD_TICKET_BLOCK_REASON]: {
    id: "74",
    title: ClaimGroupMessages.loadTicketBlockReason
  },
  [EClaimGroupModule.PUMPING_BLOCK_REASON]: {
    id: "75",
    title: ClaimGroupMessages.pumpingBlockReason
  },
  [EClaimGroupModule.DAILY_PRODUCTION_CLOSING_INCONSISTENCIES]: {
    id: "76",
    title: ClaimGroupMessages.dailyProductionClosingInconsistencies
  },
  [EClaimGroupModule.BATCHPORTAL_MAINTENANCE_VIEW]: {
    id: "77",
    title: ClaimGroupMessages.batchMaintenanceView
  },
  [EClaimGroupModule.BATCHPORTAL_MAINTENANCE_EDIT]: {
    id: "78",
    title: ClaimGroupMessages.batchMaintenanceEdit
  },
  [EClaimGroupModule.BATCHPORTAL_MAINTENANCE_EXECUTE]: {
    id: "79",
    title: ClaimGroupMessages.batchMaintenanceExecute
  },
  [EClaimGroupModule.BATCHPORTAL_AUTOMATION_VIEW]: {
    id: "80",
    title: ClaimGroupMessages.batchAutomationView
  },
  [EClaimGroupModule.BATCHPORTAL_AUTOMATION_EXECUTE]: {
    id: "81",
    title: ClaimGroupMessages.batchAutomationExecute
  },
  [EClaimGroupModule.BATCHPORTAL_AUTOMATION_ADMIN]: {
    id: "82",
    title: ClaimGroupMessages.batchAutomationAdmin
  },
  [EClaimGroupModule.BATCHPORTAL_AUTOMATION_SUPER_ADMIN]: {
    id: "83",
    title: ClaimGroupMessages.batchAutomationSuperAdmin
  },
  [EClaimGroupModule.TIME_RECORDS]: {
    id: "84",
    title: ClaimGroupMessages.timeRecords
  },
  [EClaimGroupModule.TIME_CLOCK_CONFIGURATIONS]: {
    id: "85",
    title: ClaimGroupMessages.timeClockConfigurations
  },
  [EClaimGroupModule.PERFORMANCE]: {
    id: "86",
    title: ClaimGroupMessages.performance
  },
  [EClaimGroupModule.LABORATORY_MODULE]: {
    id: "87",
    title: ClaimGroupMessages.laboratoryModule
  },
  [EClaimGroupModule.SPECIMEN_COLLECTION]: {
    id: "88",
    title: ClaimGroupMessages.specimenCollection
  },
  [EClaimGroupModule.SPECIMEN_RUPTURE]: {
    id: "89",
    title: ClaimGroupMessages.specimenRupture
  },
  [EClaimGroupModule.DELIVERY_TICKET_SPECIMENS]: {
    id: "90",
    title: ClaimGroupMessages.deliveryTicketSpecimens
  },
  [EClaimGroupModule.COLLECTION_SCHEDULE]: {
    id: "91",
    title: ClaimGroupMessages.collectionSchedule
  },
  [EClaimGroupModule.RUPTURE_SCHEDULE]: {
    id: "92",
    title: ClaimGroupMessages.ruptureSchedule
  },
  [EClaimGroupModule.ISSUE_CERTIFICATE]: {
    id: "93",
    title: ClaimGroupMessages.issueCertificate
  },
  [EClaimGroupModule.ISSUED_CERTIFICATES]: {
    id: "94",
    title: ClaimGroupMessages.issuedCertificates
  },
  [EClaimGroupModule.PRESSES]: {
    id: "95",
    title: ClaimGroupMessages.presses
  },
  [EClaimGroupModule.CERTIFICATE_PARAMETERS]: {
    id: "96",
    title: ClaimGroupMessages.certificateParameters
  },
  [EClaimGroupModule.LABORATORY_STATISTICS]: {
    id: "97",
    title: ClaimGroupMessages.laboratoryStatistics
  },
  [EClaimGroupModule.LOW_STRENGTH_APPROVAL]: {
    id: "98",
    title: ClaimGroupMessages.lowStrengthApproval
  }
};

export { EClaimGroupModule, claimGroupObject };
